import { Pipe, PipeTransform } from '@angular/core';
import { util } from '../../core/util/util';
import moment from 'moment';
import { appSettings } from 'app/appSettings';

@Pipe({ name: 'stringdate' })
export class StringDatePipe implements PipeTransform {
  transform(dateAsString) {
    try {
      const date = dateAsString && util.parseDateString(dateAsString);
      date.month = date.month - 1;
      return (date && moment(date).format(appSettings.DATE_FORMAT_MOMENT)) || dateAsString;
    } catch (e) {
      return dateAsString;
    }
  }
}
